import React from 'react'

const citiesContext = React.createContext({});

export { citiesContext }
